import { render } from "./CompareView.vue?vue&type=template&id=63037f68&scoped=true"
import script from "./CompareView.vue?vue&type=script&lang=js"
export * from "./CompareView.vue?vue&type=script&lang=js"

import "./CompareView.vue?vue&type=style&index=0&id=63037f68&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63037f68"]])

export default __exports__